import { Combo } from "./combo.model";
import { Natureza } from "./natureza.model";
import { CursoInstrutor } from "./curso-instrutor";
import { EventoInstrutor } from "./evento-instrutor";
import { AnexoInstrutor } from "./curriculo-instrutor.models";
import { FormacaoAcademicaInstrutor } from "./formacao-academica-instrutor.models";

export class Instrutor {
    public id: number;
    public nome: string;
    public cpf_passaporte: string;
    public registro_profissional: string;
    public tipo_documento: number;
    public flg_termoLGPD: boolean;

    public anexo_instrutor: AnexoInstrutor[];
    public curso_instrutor: CursoInstrutor[];
    public evento_instrutor: EventoInstrutor[];
    public formacao_academica_instrutor: FormacaoAcademicaInstrutor[];
 
}


// WEBPACK FOOTER //
// ./src/app/entity/instrutor.model.ts